const iconSvg = {
  dashboard: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3333 6.66671H12.6667C14 6.66671 14.6667 6.00004 14.6667 4.66671V3.33337C14.6667 2.00004 14 1.33337 12.6667 1.33337H11.3333C9.99999 1.33337 9.33333 2.00004 9.33333 3.33337V4.66671C9.33333 6.00004 9.99999 6.66671 11.3333 6.66671Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33333 14.6667H4.66666C6 14.6667 6.66666 14 6.66666 12.6667V11.3334C6.66666 10 6 9.33337 4.66666 9.33337H3.33333C1.99999 9.33337 1.33333 10 1.33333 11.3334V12.6667C1.33333 14 1.99999 14.6667 3.33333 14.6667Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M3.99999 6.66671C5.47275 6.66671 6.66666 5.4728 6.66666 4.00004C6.66666 2.52728 5.47275 1.33337 3.99999 1.33337C2.52724 1.33337 1.33333 2.52728 1.33333 4.00004C1.33333 5.4728 2.52724 6.66671 3.99999 6.66671Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M12 14.6667C13.4728 14.6667 14.6667 13.4728 14.6667 12C14.6667 10.5273 13.4728 9.33337 12 9.33337C10.5272 9.33337 9.33333 10.5273 9.33333 12C9.33333 13.4728 10.5272 14.6667 12 14.6667Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  listMember: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M11.9984 4.77338C11.9584 4.76671 11.9118 4.76671 11.8718 4.77338C10.9518 4.74004 10.2184 3.98671 10.2184 3.05338C10.2184 2.10004 10.9851 1.33337 11.9384 1.33337C12.8918 1.33337 13.6584 2.10671 13.6584 3.05338C13.6518 3.98671 12.9184 4.74004 11.9984 4.77338Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M11.3117 9.62669C12.225 9.78003 13.2317 9.62003 13.9383 9.14669C14.8783 8.52003 14.8783 7.49336 13.9383 6.86669C13.225 6.39336 12.205 6.23336 11.2917 6.39336"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M3.97833 4.77338C4.01833 4.76671 4.065 4.76671 4.105 4.77338C5.025 4.74004 5.75833 3.98671 5.75833 3.05338C5.75833 2.10004 4.99166 1.33337 4.03833 1.33337C3.085 1.33337 2.31833 2.10671 2.31833 3.05338C2.325 3.98671 3.05833 4.74004 3.97833 4.77338Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M4.66499 9.62669C3.75166 9.78003 2.74499 9.62003 2.03833 9.14669C1.09833 8.52003 1.09833 7.49336 2.03833 6.86669C2.75166 6.39336 3.77166 6.23336 4.68499 6.39336"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 9.75336C7.96 9.74669 7.91333 9.74669 7.87333 9.75336C6.95333 9.72002 6.22 8.96669 6.22 8.03336C6.22 7.08002 6.98667 6.31335 7.94 6.31335C8.89333 6.31335 9.66 7.08669 9.66 8.03336C9.65333 8.96669 8.92 9.72669 8 9.75336Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.06 11.8534C5.12 12.48 5.12 13.5067 6.06 14.1334C7.12666 14.8467 8.87333 14.8467 9.94 14.1334C10.88 13.5067 10.88 12.48 9.94 11.8534C8.88 11.1467 7.12666 11.1467 6.06 11.8534Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  pointManagement: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.4">
        <path
          d="M5.33333 7.60017C5.33333 8.1135 5.73333 8.5335 6.21999 8.5335H7.21999C7.64666 8.5335 7.99333 8.16684 7.99333 7.72017C7.99333 7.2335 7.77999 7.06017 7.46666 6.94684L5.86666 6.38684C5.54666 6.2735 5.33333 6.10017 5.33333 5.6135C5.33333 5.16684 5.67999 4.80017 6.10666 4.80017H7.10666C7.59999 4.80684 7.99999 5.22017 7.99999 5.7335"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66667 8.56641V9.05974"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66667 4.27344V4.79344"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M6.65999 11.9867C9.60183 11.9867 11.9867 9.60188 11.9867 6.66004C11.9867 3.7182 9.60183 1.33337 6.65999 1.33337C3.71816 1.33337 1.33333 3.7182 1.33333 6.66004C1.33333 9.60188 3.71816 11.9867 6.65999 11.9867Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M8.65334 13.2533C9.25334 14.1 10.2333 14.6533 11.3533 14.6533C13.1733 14.6533 14.6533 13.1733 14.6533 11.3533C14.6533 10.2466 14.1067 9.26663 13.2733 8.66663"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  memberVoucher: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 8.33329C13 7.41329 13.7467 6.66663 14.6667 6.66663V5.99996C14.6667 3.33329 14 2.66663 11.3333 2.66663H4.66668C2.00001 2.66663 1.33334 3.33329 1.33334 5.99996V6.33329C2.25334 6.33329 3.00001 7.07996 3.00001 7.99996C3.00001 8.91996 2.25334 9.66663 1.33334 9.66663V9.99996C1.33334 12.6666 2.00001 13.3333 4.66668 13.3333H11.3333C14 13.3333 14.6667 12.6666 14.6667 9.99996C13.7467 9.99996 13 9.25329 13 8.33329Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M6.66666 2.66663L6.66666 13.3333"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="5 5"
      />
    </svg>
  ),
  complaint: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.99999 14.6667H9.99999C13.3333 14.6667 14.6667 13.3334 14.6667 10V6.00004C14.6667 2.66671 13.3333 1.33337 9.99999 1.33337H5.99999C2.66666 1.33337 1.33333 2.66671 1.33333 6.00004V10C1.33333 13.3334 2.66666 14.6667 5.99999 14.6667Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M4.66667 5.83337C5.33334 5.16671 6.42001 5.16671 7.09334 5.83337"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M8.90666 5.83337C9.57333 5.16671 10.66 5.16671 11.3333 5.83337"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M5.6 11.8H10.4C10.7333 11.8 11 11.5333 11 11.2C11 9.53995 9.66 8.19995 8 8.19995C6.34 8.19995 5 9.53995 5 11.2C5 11.5333 5.26667 11.8 5.6 11.8Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  regionMaster: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 14.6667H10C13.3333 14.6667 14.6667 13.3334 14.6667 10V6.00004C14.6667 2.66671 13.3333 1.33337 10 1.33337H6C2.66666 1.33337 1.33333 2.66671 1.33333 6.00004V10C1.33333 13.3334 2.66666 14.6667 6 14.6667Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g opacity="0.4">
        <path
          d="M6 1.33337L9.30001 14.6667"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.68668 8.14673L1.33333 10.0001"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  listArea: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6667 6.00005V10.0001C14.6667 11.6667 14.3333 12.8334 13.5867 13.5867L9.33333 9.33338L14.4867 4.18005C14.6067 4.70672 14.6667 5.30672 14.6667 6.00005Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4867 4.18004L4.17999 14.4867C2.17332 14.0267 1.33333 12.64 1.33333 10V6.00004C1.33333 2.66671 2.66666 1.33337 5.99999 1.33337H9.99999C12.64 1.33337 14.0267 2.17338 14.4867 4.18004Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5867 13.5867C12.8333 14.3334 11.6667 14.6667 10 14.6667H6C5.30667 14.6667 4.70666 14.6067 4.17999 14.4867L9.33333 9.33337L13.5867 13.5867Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M4.15999 5.31998C4.61333 3.36665 7.54667 3.36665 8 5.31998C8.26 6.46665 7.53999 7.43998 6.90666 8.03998C6.44666 8.47998 5.72 8.47998 5.25334 8.03998C4.62 7.43998 3.89333 6.46665 4.15999 5.31998Z"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <path
        opacity="0.4"
        d="M6.06307 5.80001H6.06906"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  listOutlet: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99999 8.00004C9.21999 8.00004 10.12 7.00671 9.99999 5.78671L9.55999 1.33337H6.44666L5.99999 5.78671C5.87999 7.00671 6.77999 8.00004 7.99999 8.00004Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2067 8.00004C13.5533 8.00004 14.54 6.90671 14.4067 5.56671L14.22 3.73337C13.98 2.00004 13.3133 1.33337 11.5667 1.33337H9.53334L10 6.00671C10.1133 7.10671 11.1067 8.00004 12.2067 8.00004Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.76 8.00004C4.86 8.00004 5.85333 7.10671 5.96 6.00671L6.10666 4.53337L6.42666 1.33337H4.39333C2.64666 1.33337 1.98 2.00004 1.74 3.73337L1.56 5.56671C1.42666 6.90671 2.41333 8.00004 3.76 8.00004Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g opacity="0.4">
        <path
          d="M2.00652 7.47986V10.4732C2.00652 13.4665 3.20652 14.6665 6.19985 14.6665H9.79318C12.7865 14.6665 13.9865 13.4665 13.9865 10.4732V7.47986"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.99999 11.3334C6.88666 11.3334 6.33333 11.8867 6.33333 13V14.6667H9.66666V13C9.66666 11.8867 9.11333 11.3334 7.99999 11.3334Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  masterCategory: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.62 4.50671L12.3733 13.5267C12.2133 14.2001 11.6133 14.6667 10.92 14.6667H2.15998C1.15332 14.6667 0.433329 13.68 0.733329 12.7133L3.53999 3.70007C3.73332 3.07341 4.31333 2.64001 4.96667 2.64001H13.1667C13.8 2.64001 14.3267 3.02668 14.5467 3.56002C14.6733 3.84668 14.7 4.17338 14.62 4.50671Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
      />
      <path
        opacity="0.4"
        d="M10.6667 14.6667H13.8533C14.7133 14.6667 15.3867 13.94 15.3267 13.08L14.6667 4"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.45332 4.25338L7.14666 1.37341"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.92 4.26001L11.5467 1.3667"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M5.13335 8H10.4667"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M4.46667 10.6666H9.80001"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  listProduct: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6467 14.6667H3.31334C1.31334 14.6667 1.31334 13.7667 1.31334 12.6667V12C1.31334 11.6334 1.61334 11.3334 1.98001 11.3334H13.98C14.3467 11.3334 14.6467 11.6334 14.6467 12V12.6667C14.6467 13.7667 14.6467 14.6667 12.6467 14.6667Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8133 8.66671V11.3334H2.17999V8.66671C2.17999 6.10671 3.98666 3.96671 6.39333 3.45337C6.75333 3.37337 7.12666 3.33337 7.51333 3.33337H8.47999C8.86666 3.33337 9.24666 3.37337 9.60666 3.45337C12.0133 3.97337 13.8133 6.10671 13.8133 8.66671Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M9.66666 3.00004C9.66666 3.16004 9.64666 3.30671 9.60666 3.45337C9.24666 3.37337 8.86666 3.33337 8.47999 3.33337H7.51333C7.12666 3.33337 6.75333 3.37337 6.39333 3.45337C6.35333 3.30671 6.33333 3.16004 6.33333 3.00004C6.33333 2.08004 7.07999 1.33337 7.99999 1.33337C8.91999 1.33337 9.66666 2.08004 9.66666 3.00004Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M10 7.33337H6"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  storefrontProductList: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33333 14.6666H14.6667"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.07333 14.6666V8.66663C2.07333 7.55996 3.06667 6.66663 4.29333 6.66663H11.7C12.9267 6.66663 13.92 7.55996 13.92 8.66663V14.6666"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.70667 6.66671V4.78004C3.70667 3.98004 4.42667 3.33337 5.32 3.33337H10.6867C11.5733 3.33337 12.2933 3.98004 12.2933 4.78004V6.66671"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M2.35333 9.31995L2.6 9.32661C3.09333 9.33328 3.48667 9.73328 3.48667 10.2266V10.4466C3.48667 10.9399 3.88667 11.3466 4.38667 11.3466C4.88 11.3466 5.28667 10.9466 5.28667 10.4466V10.2399C5.28667 9.74661 5.68667 9.33995 6.18667 9.33995C6.68 9.33995 7.08667 9.73995 7.08667 10.2399V10.4466C7.08667 10.9399 7.48667 11.3466 7.98667 11.3466C8.48 11.3466 8.88667 10.9466 8.88667 10.4466V10.2399C8.88667 9.74661 9.28667 9.33995 9.78667 9.33995C10.28 9.33995 10.6867 9.73995 10.6867 10.2399V10.4466C10.6867 10.9399 11.0867 11.3466 11.5867 11.3466C12.08 11.3466 12.4867 10.9466 12.4867 10.4466V10.2399C12.4867 9.74661 12.8867 9.33995 13.3867 9.33995H13.6867"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M5.33333 3.33333V2"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M10.6667 3.33333V2"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M8 3.33337V1.33337"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  historyPayment: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.4">
        <path
          d="M6.33333 9.1667C6.33333 9.81336 6.83334 10.3334 7.44667 10.3334H8.69999C9.23332 10.3334 9.66666 9.88003 9.66666 9.31336C9.66666 8.7067 9.4 8.4867 9.00667 8.3467L6.99999 7.6467C6.60666 7.5067 6.34 7.29337 6.34 6.68003C6.34 6.12003 6.77332 5.66003 7.30666 5.66003H8.55999C9.17333 5.66003 9.67333 6.18003 9.67333 6.8267"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 5V11"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M14.6667 8.00004C14.6667 11.68 11.68 14.6667 7.99999 14.6667C4.31999 14.6667 1.33333 11.68 1.33333 8.00004C1.33333 4.32004 4.31999 1.33337 7.99999 1.33337"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3333 2V4.66667H14"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 1.33337L11.3333 4.66671"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  orderList: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33333 1.33337H2.49333C3.21333 1.33337 3.78 1.95337 3.72 2.66671L3.16666 9.3067C3.07333 10.3934 3.93332 11.3267 5.02666 11.3267H12.1267C13.0867 11.3267 13.9267 10.54 14 9.58671L14.36 4.58671C14.44 3.48004 13.6 2.58004 12.4867 2.58004H3.88"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M10.8333 14.6667C11.2936 14.6667 11.6667 14.2936 11.6667 13.8333C11.6667 13.3731 11.2936 13 10.8333 13C10.3731 13 10 13.3731 10 13.8333C10 14.2936 10.3731 14.6667 10.8333 14.6667Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M5.50001 14.6667C5.96024 14.6667 6.33334 14.2936 6.33334 13.8333C6.33334 13.3731 5.96024 13 5.50001 13C5.03977 13 4.66667 13.3731 4.66667 13.8333C4.66667 14.2936 5.03977 14.6667 5.50001 14.6667Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M6 5.33337H14"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  exchangeVoucher: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.26823 13.2467H11.5816C14.0482 13.2467 14.6616 12.6334 14.6616 10.1667C13.8082 10.1667 13.1216 9.47338 13.1216 8.62672C13.1216 7.77338 13.8082 7.08005 14.6616 7.08005V6.46672C14.6616 4.00005 14.0482 3.38672 11.5816 3.38672H7.32823V7.91339"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M7.32904 11.2466V13.2466H5.48237C4.4957 13.2466 3.91571 12.5733 3.27571 11.0266L3.1557 10.7266C3.96237 10.4066 4.35571 9.47329 4.01571 8.66663C3.68904 7.85996 2.76237 7.47329 1.94904 7.80663L1.8357 7.51996C0.875705 5.17329 1.20904 4.35329 3.55571 3.38663L5.31571 2.66663L7.32904 7.54663V9.24663"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.44146 13.2467H5.32812"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  promo: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 8.33329C13 7.41329 13.7467 6.66663 14.6667 6.66663V5.99996C14.6667 3.33329 14 2.66663 11.3333 2.66663H4.66666C1.99999 2.66663 1.33333 3.33329 1.33333 5.99996V6.33329C2.25333 6.33329 2.99999 7.07996 2.99999 7.99996C2.99999 8.91996 2.25333 9.66663 1.33333 9.66663V9.99996C1.33333 12.6666 1.99999 13.3333 4.66666 13.3333H11.3333C14 13.3333 14.6667 12.6666 14.6667 9.99996C13.7467 9.99996 13 9.25329 13 8.33329Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M6 9.83337L10 5.83337"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M9.99634 9.83333H10.0023"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M5.99634 6.16671H6.00233"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  broadcast: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6667 6.66671V8.66671C14.6667 11.3334 13.3333 12.6667 10.6667 12.6667H10.3333C10.1267 12.6667 9.92666 12.7667 9.79999 12.9334L8.79999 14.2667C8.35999 14.8534 7.63999 14.8534 7.19999 14.2667L6.19999 12.9334C6.09333 12.7867 5.84666 12.6667 5.66666 12.6667H5.33333C2.66666 12.6667 1.33333 12 1.33333 8.66671V5.33337C1.33333 2.66671 2.66666 1.33337 5.33333 1.33337H9.33333"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M13 4.66671C13.9205 4.66671 14.6667 3.92052 14.6667 3.00004C14.6667 2.07957 13.9205 1.33337 13 1.33337C12.0795 1.33337 11.3333 2.07957 11.3333 3.00004C11.3333 3.92052 12.0795 4.66671 13 4.66671Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M10.6643 7.33333H10.6703"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M7.99698 7.33333H8.00297"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M5.32967 7.33333H5.33566"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  badge: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1333 12.6534H4.86666C4.58666 12.6534 4.27333 12.4334 4.18 12.1667L1.42 4.4467C1.02666 3.34003 1.48666 3.00003 2.43333 3.68003L5.03333 5.54003C5.46666 5.84003 5.96 5.6867 6.14666 5.20003L7.32 2.07336C7.69333 1.07336 8.31333 1.07336 8.68666 2.07336L9.86 5.20003C10.0467 5.6867 10.54 5.84003 10.9667 5.54003L13.4067 3.80003C14.4467 3.05336 14.9467 3.43336 14.52 4.64003L11.8267 12.18C11.7267 12.4334 11.4133 12.6534 11.1333 12.6534Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M4.33333 14.6666H11.6667"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M6.33333 9.33337H9.66666"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  voucherManagement: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.26823 13.2467H11.5816C14.0482 13.2467 14.6616 12.6334 14.6616 10.1667C13.8082 10.1667 13.1216 9.47338 13.1216 8.62672C13.1216 7.77338 13.8082 7.08005 14.6616 7.08005V6.46672C14.6616 4.00005 14.0482 3.38672 11.5816 3.38672H7.32823V7.91339"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M7.32904 11.2466V13.2466H5.48237C4.4957 13.2466 3.91571 12.5733 3.27571 11.0266L3.1557 10.7266C3.96237 10.4066 4.35571 9.47329 4.01571 8.66663C3.68904 7.85996 2.76237 7.47329 1.94904 7.80663L1.8357 7.51996C0.875705 5.17329 1.20904 4.35329 3.55571 3.38663L5.31571 2.66663L7.32904 7.54663V9.24663"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.44146 13.2467H5.32812"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  pointPayment: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M12.3332 8.43457V10.9012C12.3332 12.9812 10.3932 14.6679 7.99984 14.6679C5.6065 14.6679 3.6665 12.9812 3.6665 10.9012V8.43457C3.6665 10.5146 5.6065 12.0012 7.99984 12.0012C10.3932 12.0012 12.3332 10.5146 12.3332 8.43457Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3337 5.10065C12.3337 5.70732 12.167 6.26732 11.8737 6.74732C11.1603 7.92065 9.69366 8.66732 8.00033 8.66732C6.30699 8.66732 4.84033 7.92065 4.12699 6.74732C3.83366 6.26732 3.66699 5.70732 3.66699 5.10065C3.66699 4.06065 4.15365 3.12065 4.93365 2.44065C5.72032 1.75398 6.80033 1.33398 8.00033 1.33398C9.20033 1.33398 10.2803 1.75399 11.067 2.43399C11.847 3.12065 12.3337 4.06065 12.3337 5.10065Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3337 5.10065V8.43398C12.3337 10.514 10.3937 12.0007 8.00033 12.0007C5.60699 12.0007 3.66699 10.514 3.66699 8.43398V5.10065C3.66699 3.02065 5.60699 1.33398 8.00033 1.33398C9.20033 1.33398 10.2803 1.75399 11.067 2.43399C11.847 3.12065 12.3337 4.06065 12.3337 5.10065Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  delivery: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M8 9.33325H8.66667C9.4 9.33325 10 8.73325 10 7.99992V1.33325H4C3 1.33325 2.12667 1.88658 1.67334 2.69991"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33333 11.3333C1.33333 12.4399 2.22666 13.3333 3.33333 13.3333H3.99999C3.99999 12.5999 4.59999 11.9999 5.33333 11.9999C6.06666 11.9999 6.66666 12.5999 6.66666 13.3333H9.33333C9.33333 12.5999 9.93333 11.9999 10.6667 11.9999C11.4 11.9999 12 12.5999 12 13.3333H12.6667C13.7733 13.3333 14.6667 12.4399 14.6667 11.3333V9.33325H12.6667C12.3 9.33325 12 9.03325 12 8.66659V6.66659C12 6.29992 12.3 5.99992 12.6667 5.99992H13.5266L12.3867 4.00659C12.1467 3.59326 11.7067 3.33325 11.2267 3.33325H9.99999V7.99992C9.99999 8.73325 9.39999 9.33325 8.66666 9.33325H7.99999"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33333 14.6667C6.06971 14.6667 6.66667 14.0697 6.66667 13.3333C6.66667 12.597 6.06971 12 5.33333 12C4.59695 12 4 12.597 4 13.3333C4 14.0697 4.59695 14.6667 5.33333 14.6667Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6667 14.6667C11.403 14.6667 12 14.0697 12 13.3333C12 12.597 11.403 12 10.6667 12C9.93028 12 9.33333 12.597 9.33333 13.3333C9.33333 14.0697 9.93028 14.6667 10.6667 14.6667Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 8V9.33333H12.6667C12.3 9.33333 12 9.03333 12 8.66667V6.66667C12 6.3 12.3 6 12.6667 6H13.5267L14.6667 8Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33333 5.33325H5.33333"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33333 7.33325H3.99999"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33333 9.33325H2.66666"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  complaintCategory: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.98001 14.6666C11.6619 14.6666 14.6467 11.6818 14.6467 7.99992C14.6467 4.31802 11.6619 1.33325 7.98001 1.33325C4.29811 1.33325 1.31334 4.31802 1.31334 7.99992C1.31334 11.6818 4.29811 14.6666 7.98001 14.6666Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M11.1933 11.6667C10.4933 10.6601 9.32001 10.0001 8.00001 10.0001C6.68001 10.0001 5.51334 10.6601 4.80668 11.6667"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  adminManagement: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12.5734H11.4933C10.96 12.5734 10.4533 12.7801 10.08 13.1534L8.93998 14.2801C8.41998 14.7934 7.57334 14.7934 7.05334 14.2801L5.91333 13.1534C5.54 12.7801 5.02667 12.5734 4.5 12.5734H4C2.89333 12.5734 2 11.6868 2 10.5934V3.32007C2 2.22674 2.89333 1.34009 4 1.34009H12C13.1067 1.34009 14 2.22674 14 3.32007V10.5934C14 11.6801 13.1067 12.5734 12 12.5734Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M8 6.66671C8.85788 6.66671 9.55334 5.97124 9.55334 5.11336C9.55334 4.25548 8.85788 3.56006 8 3.56006C7.14212 3.56006 6.44666 4.25548 6.44666 5.11336C6.44666 5.97124 7.14212 6.66671 8 6.66671Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M10.6667 10.4399C10.6667 9.2399 9.47333 8.2666 7.99999 8.2666C6.52666 8.2666 5.33333 9.2399 5.33333 10.4399"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  reportBrown: (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.6667 6.99998V9.82331C25.6667 11.6666 24.5001 12.8333 22.6567 12.8333H18.6667V4.67831C18.6667 3.38331 19.7284 2.33331 21.0234 2.33331C22.2951 2.34498 23.4618 2.85831 24.3018 3.69831C25.1418 4.54998 25.6667 5.71665 25.6667 6.99998Z"
        stroke="#AB6D34"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.33325 8.16665V24.5C2.33325 25.4683 3.42989 26.0166 4.19989 25.4333L6.19492 23.94C6.66158 23.59 7.31492 23.6366 7.73492 24.0566L9.67156 26.005C10.1266 26.46 10.8733 26.46 11.3283 26.005L13.2883 24.045C13.6966 23.6366 14.3499 23.59 14.8049 23.94L16.7999 25.4333C17.5699 26.005 18.6666 25.4566 18.6666 24.5V4.66665C18.6666 3.38331 19.7166 2.33331 20.9999 2.33331H8.16659H6.99992C3.49992 2.33331 2.33325 4.42165 2.33325 6.99998V8.16665Z"
        stroke="#AB6D34"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M7 10.5H14"
        stroke="#AB6D34"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M7.875 15.1667H13.125"
        stroke="#AB6D34"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  memberBrown: (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M20.9973 8.35332C20.9273 8.34165 20.8457 8.34165 20.7757 8.35332C19.1657 8.29498 17.8823 6.97665 17.8823 5.34332C17.8823 3.67498 19.224 2.33331 20.8923 2.33331C22.5607 2.33331 23.9023 3.68665 23.9023 5.34332C23.8907 6.97665 22.6073 8.29498 20.9973 8.35332Z"
        stroke="#AB6D34"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M19.7955 16.8467C21.3938 17.115 23.1555 16.835 24.3922 16.0067C26.0372 14.91 26.0372 13.1133 24.3922 12.0167C23.1438 11.1883 21.3588 10.9083 19.7605 11.1883"
        stroke="#AB6D34"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M6.96213 8.35332C7.03213 8.34165 7.1138 8.34165 7.1838 8.35332C8.7938 8.29498 10.0771 6.97665 10.0771 5.34332C10.0771 3.67498 8.73546 2.33331 7.06713 2.33331C5.3988 2.33331 4.05713 3.68665 4.05713 5.34332C4.0688 6.97665 5.35213 8.29498 6.96213 8.35332Z"
        stroke="#AB6D34"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M8.16367 16.8467C6.56533 17.115 4.80367 16.835 3.567 16.0067C1.922 14.91 1.922 13.1133 3.567 12.0167C4.81534 11.1883 6.60033 10.9083 8.19867 11.1883"
        stroke="#AB6D34"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 17.0683C13.93 17.0567 13.8483 17.0567 13.7783 17.0683C12.1683 17.01 10.885 15.6917 10.885 14.0583C10.885 12.39 12.2267 11.0483 13.895 11.0483C15.5633 11.0483 16.905 12.4017 16.905 14.0583C16.8933 15.6917 15.61 17.0217 14 17.0683Z"
        stroke="#AB6D34"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6051 20.7434C8.96009 21.84 8.96009 23.6367 10.6051 24.7334C12.4718 25.9817 15.5284 25.9817 17.3951 24.7334C19.0401 23.6367 19.0401 21.84 17.3951 20.7434C15.5401 19.5067 12.4718 19.5067 10.6051 20.7434Z"
        stroke="#AB6D34"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  outletBrown: (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 14C16.135 14 17.71 12.2616 17.5 10.1266L16.73 2.33331H11.2817L10.5 10.1266C10.29 12.2616 11.865 14 14 14Z"
        stroke="#AB6D34"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3617 14C23.7183 14 25.445 12.0866 25.2117 9.74165L24.885 6.53331C24.465 3.49998 23.2983 2.33331 20.2417 2.33331H16.6833L17.5 10.5116C17.6983 12.4366 19.4367 14 21.3617 14Z"
        stroke="#AB6D34"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.58011 14C8.50511 14 10.2434 12.4366 10.4301 10.5116L10.6868 7.93331L11.2468 2.33331H7.68844C4.63177 2.33331 3.46511 3.49998 3.04511 6.53331L2.73011 9.74165C2.49677 12.0866 4.22344 14 6.58011 14Z"
        stroke="#AB6D34"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g opacity="0.4">
        <path
          d="M3.51147 13.0897V18.328C3.51147 23.5663 5.61147 25.6663 10.8498 25.6663H17.1381C22.3765 25.6663 24.4765 23.5663 24.4765 18.328V13.0897"
          stroke="#AB6D34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.0002 19.8333C12.0518 19.8333 11.0835 20.8016 11.0835 22.75V25.6666H16.9168V22.75C16.9168 20.8016 15.9485 19.8333 14.0002 19.8333Z"
          stroke="#AB6D34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  pointBrown: (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M21.5834 14.7584V19.075C21.5834 22.715 18.1884 25.6667 14.0001 25.6667C9.81175 25.6667 6.41675 22.715 6.41675 19.075V14.7584C6.41675 18.3984 9.81175 21 14.0001 21C18.1884 21 21.5834 18.3984 21.5834 14.7584Z"
        stroke="#AB6D34"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5834 8.92498C21.5834 9.98665 21.2917 10.9666 20.7784 11.8066C19.5301 13.86 16.9634 15.1666 14.0001 15.1666C11.0367 15.1666 8.47008 13.86 7.22175 11.8066C6.70842 10.9666 6.41675 9.98665 6.41675 8.92498C6.41675 7.10498 7.26841 5.45998 8.63341 4.26998C10.0101 3.06831 11.9001 2.33331 14.0001 2.33331C16.1001 2.33331 17.9901 3.06831 19.3668 4.25831C20.7318 5.45998 21.5834 7.10498 21.5834 8.92498Z"
        stroke="#AB6D34"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5834 8.92498V14.7583C21.5834 18.3983 18.1884 21 14.0001 21C9.81175 21 6.41675 18.3983 6.41675 14.7583V8.92498C6.41675 5.28498 9.81175 2.33331 14.0001 2.33331C16.1001 2.33331 17.9901 3.06831 19.3668 4.25831C20.7318 5.45998 21.5834 7.10498 21.5834 8.92498Z"
        stroke="#AB6D34"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  imgPhoto: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={'1'}>
        <path
          d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 11C10.1046 11 11 10.1046 11 9C11 7.89543 10.1046 7 9 7C7.89543 7 7 7.89543 7 9C7 10.1046 7.89543 11 9 11Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 14.9997L17.914 11.9137C17.5389 11.5388 17.0303 11.3281 16.5 11.3281C15.9697 11.3281 15.4611 11.5388 15.086 11.9137L6 20.9997"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  payment: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M8.00004 14.6C11.6819 14.6 14.6667 11.6152 14.6667 7.93333C14.6667 4.25143 11.6819 1.26666 8.00004 1.26666C4.31814 1.26666 1.33337 4.25143 1.33337 7.93333C1.33337 11.6152 4.31814 14.6 8.00004 14.6Z"
        fill="#AB6D34"
      />
      <path
        d="M9.50665 8L8.49998 7.64667V5.38667H8.73998C9.27998 5.38667 9.71998 5.86 9.71998 6.44C9.71998 6.71333 9.94665 6.94 10.22 6.94C10.4933 6.94 10.72 6.71333 10.72 6.44C10.72 5.30667 9.83331 4.38667 8.73998 4.38667H8.49998V4C8.49998 3.72667 8.27332 3.5 7.99998 3.5C7.72665 3.5 7.49998 3.72667 7.49998 4V4.38667H7.06665C6.07998 4.38667 5.27332 5.22 5.27332 6.24C5.27332 7.43333 5.96665 7.81333 6.49332 8L7.49998 8.35333V10.6067H7.25998C6.71998 10.6067 6.27998 10.1333 6.27998 9.55333C6.27998 9.28 6.05332 9.05333 5.77998 9.05333C5.50665 9.05333 5.27998 9.28 5.27998 9.55333C5.27998 10.6867 6.16665 11.6067 7.25998 11.6067H7.49998V12C7.49998 12.2733 7.72665 12.5 7.99998 12.5C8.27332 12.5 8.49998 12.2733 8.49998 12V11.6133H8.93332C9.91998 11.6133 10.7266 10.78 10.7266 9.76C10.72 8.56 10.0266 8.18 9.50665 8ZM6.82665 7.06C6.48665 6.94 6.27998 6.82667 6.27998 6.24667C6.27998 5.77333 6.63332 5.39333 7.07332 5.39333H7.50665V7.3L6.82665 7.06ZM8.93332 10.6133H8.49998V8.70667L9.17332 8.94C9.51332 9.06 9.71998 9.17333 9.71998 9.75333C9.71998 10.2267 9.36665 10.6133 8.93332 10.6133Z"
        fill="#AB6D34"
      />
    </svg>
  ),
  packagingMaster: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.6 4.33337H10.4C12.6667 4.33337 12.8933 5.39337 13.0467 6.68671L13.6467 11.6867C13.84 13.3267 13.3333 14.6667 11 14.6667H5.00667C2.66667 14.6667 2.16 13.3267 2.36 11.6867L2.96001 6.68671C3.10667 5.39337 3.33333 4.33337 5.6 4.33337Z"
        stroke="#888888"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M5.33333 5.33337V3.00004C5.33333 2.00004 5.99999 1.33337 6.99999 1.33337H9C10 1.33337 10.6667 2.00004 10.6667 3.00004V5.33337"
        stroke="#888888"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M13.6067 11.3533H5.33333"
        stroke="#888888"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  outletPackaging: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M5 5.11334V4.46667C5 2.96667 6.20667 1.49334 7.70667 1.35334C9.49333 1.18001 11 2.58667 11 4.34001V5.26001"
        stroke="#AB6D34"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.00001 14.6667H10C12.68 14.6667 13.16 13.5934 13.3 12.2867L13.8 8.28671C13.98 6.66004 13.5133 5.33337 10.6667 5.33337H5.33334C2.48667 5.33337 2.02001 6.66004 2.20001 8.28671L2.70001 12.2867C2.84001 13.5934 3.32001 14.6667 6.00001 14.6667Z"
        stroke="#AB6D34"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M10.3303 7.99996H10.3363"
        stroke="#AB6D34"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M5.66302 7.99996H5.669"
        stroke="#AB6D34"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
};

export default iconSvg;
